import React, {useContext, useState} from 'react';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import styles from "./modal-content-order-bulk-reject.module.scss";
import SuccessModalContent from "../modal-content-success/modal-content-success";
import {ORDER_BULK_REJECT_SUCCESS, ORDER_CONFIRM_ERROR, ORDER_REJECTED} from "../../../../../helpr/constants";
import ErrorModalContent from "../modal-content-error/modal-content-error";
import {
  REDUCER_ACTION_UPDATE_STATUS_BATCH,
  SecurityContext,
  SecurityDispatchContext
} from "../../../../../context/security-context";
import SecurityService from "../../../../../services/security-service";
import confirmIcon from "../../../../../assets/reject-orange.svg"
import {batch, toCurrency} from "../../../../../helpr/helper";

const BulkOrderRejectModalContent = ({onClose, modalConfig}) => {
  const SUCCESS_TITLE = "RESERVATIONS REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const { setModalState } = modalConfig;
  const [ loading, setLoading] = useState(false);
  const [ page, setPage ] = useState(0);
  const { ordersState, securityState } = useContext(SecurityContext);
  const { ordersDispatch } = useContext(SecurityDispatchContext);
  const securityService = new SecurityService();

  const rejectBulkOrder = async () => {
    setLoading(true);
    try {
      const batchList = ordersState.filtered.filter(o => o.checked && o.orderStatus === '0')
        .map(o => o.orderId);
      const chunks = batch(batchList, 25);
      console.log(chunks);
      for(const chunk of chunks) {
        await securityService.batchRejectOrder(securityState.securityId, chunk);
      }
      ordersDispatch({
        type: REDUCER_ACTION_UPDATE_STATUS_BATCH,
        previous: ordersState,
        data: ORDER_REJECTED
      })
      setModalState(prev => {
        return {
          ...prev,
          style: `${styles['success-modal']}`
        }
      })
      setPage(1);
    } catch(error) {
      setModalState(prev => {
        return {
          ...prev,
          style: `${styles['error-modal']}`
        }
      })
      setPage(2)
    } finally {
      setLoading(false);
    }
  }

  const batchCount = () => {
    return ordersState.filtered.filter(o => o.checked && o.orderStatus === '0').length;
  }

  const batchAmount = () => {
    return ordersState.filtered.filter(o => o.checked && o.orderStatus === '0')
      .reduce((total, o) => total + o.scaledAmount, 0);
  }

  return page === 0 ? (
    <div className={styles['bulk-reject-order']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO REJECT RESERVATIONS?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Confirm" src={confirmIcon} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="name">Reservations Selected</label></div></Col>
        <Col xs={6} lg={6}><p className={styles['value']}>{batchCount()}</p></Col>
        <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="category">Total Amount Selected</label></div></Col>
        <Col xs={6} lg={6}><p className={styles['value']}>{toCurrency(batchAmount())}</p></Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button variant="warning" disabled={loading} onClick={() => rejectBulkOrder()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'Yes'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>No</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : ( page === 1
    ? <SuccessModalContent title={SUCCESS_TITLE} message={ORDER_BULK_REJECT_SUCCESS} onClose={onClose}/>
    : <ErrorModalContent title={ERROR_TITLE} message={ORDER_CONFIRM_ERROR} onClose={onClose}/>)
}

export default BulkOrderRejectModalContent;
